// extracted by mini-css-extract-plugin
export default {"object":"ObjectsSidebar__object__sVTgg","no-objects":"ObjectsSidebar__no-objects__R4i8v","noObjects":"ObjectsSidebar__no-objects__R4i8v"};